import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  ClientStartPage = 'ClientStartPage',
}

export const queryKeys = {
  clientStartPage: (clientId: string) => [
    QueryFeature.ClientStartPage,
    QueryKey.ClientStartPage,
    clientId,
  ],
};
